import { render, staticRenderFns } from "./TabTransportPackage.vue?vue&type=template&id=2710b334"
import script from "./TabTransportPackage.vue?vue&type=script&lang=ts"
export * from "./TabTransportPackage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports